<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">
            <el-form :inline="true" :model="search">
                <el-form-item label="分类名称">
                    <el-input v-model="search.title" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" border lazy :load="load"
                :tree-props="{ children: 'Children' }" style="width: 100%" ref="table" class="custom-tbl">
                <el-table-column type="index" width="80" label="序号"></el-table-column>
                <el-table-column prop="Title" label="类型名称" width="180px"></el-table-column>
                <el-table-column prop="FirstPng" label="首图" width>
                    <template scope="scope">
                        <span v-if="scope.row.FirstPngUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.FirstPngUrl" width="100%" />
                                <img slot="reference" :src="scope.row.FirstPngUrl" :alt="scope.row.FirstPngUrl"
                                    width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="TypeClass" label="类型分类">
                    <template slot-scope="scope">
                        <el-tag type='info' disable-transitions>{{scope.row.TypeClass==1 ? "主要类型" : "动态类型" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="Ioc" label="图标" width>
                    <template scope="scope">
                        <span v-if="scope.row.IocUrl">
                            <el-popover placement="left" trigger="click" style="width:200px;cursor:pointer;">
                                <img :src="scope.row.IocUrl" width="100%" />
                                <img slot="reference" :src="scope.row.IocUrl" :alt="scope.row.IocUrl" width="60"
                                    height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Ioc" label="图标Click" width>
                    <template scope="scope">
                        <span v-if="scope.row.IocClickUrl">
                            <el-popover placement="left" trigger="click" style="width:200px;cursor:pointer;">
                                <img :src="scope.row.IocClickUrl" width="100%" />
                                <img slot="reference" :src="scope.row.IocClickUrl" :alt="scope.row.IocClickUrl"
                                    width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Sort" label="排序" width></el-table-column>
                <el-table-column prop="CreateBy" label="创建用户" width></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width></el-table-column>
                <el-table-column prop="Status" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Status == 0 ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.Status == 0 ? "启用" : "停用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template scope="scope">
                        <el-button size="small" type="primary"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('update') != -1).length > 0"
                            @click="update(scope.row)">编辑</el-button>
                        <el-button type="danger" size="small"
                            v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                            @click="handledel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>


        <!--修改界面-->
        <el-dialog title="数据修改" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
            <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
                <el-form-item label="所属分类" prop="PId">
                    <el-cascader style="width: 100%" v-model="editForm.PId" :options="TypeList" :props="{
                            expandTrigger: 'hover',
                            children: 'Children',
                            label: 'Title',
                            value: 'Id',
                        }" @change="edithandleChange" filterable change-on-select>
                    </el-cascader>
                </el-form-item>
                <el-form-item label="类型名称" prop="Title">
                    <el-input v-model="editForm.Title" type="Text" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="类型分类" prop="TypeClass">
                    <el-radio-group v-model="editForm.TypeClass">
                        <el-radio :label="1">主要类型</el-radio>
                        <el-radio :label="2">动态类型</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="品牌标识" prop="BrandType">
                    <selectPBBrand style="width: 100%" v-model="editForm.BrandType">
                    </selectPBBrand>
                </el-form-item>
                <el-form-item label="产品状态" prop="Status">
                    <el-radio-group v-model="editForm.Status">
                        <el-radio :label="0">启用</el-radio>
                        <el-radio :label="1">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="首图" prop="FirstPng">
                    <ImageFile :value="firtimgList" :imgLimit="1" @change="firtImageChange"></ImageFile>
                </el-form-item>
                <el-form-item label="图标" prop="Ioc">
                    <ImageFile :value="IocimgList" :imgLimit="1" @change="IocImageChange"></ImageFile>
                </el-form-item>
                <el-form-item label="图标Click" prop="Ioc">
                    <ImageFile :value="ClickimgList" :imgLimit="1" @change="ClickImageChange"></ImageFile>
                </el-form-item>
                <el-form-item label="排序" prop="Sort">
                    <el-input v-model="editForm.Sort" type="number" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import util from '../../../../util/date'
    import {getButtonList} from "../../../promissionRouter";
    import {getPBTypePageList,removePBType,GetTypeListAsync,Post} from '../../../api/api';

    let id = 1000;

    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:30,
                listLoading: false,
                data:[],
                
                //修改
                editFormVisible:false,  //窗口是否显示
                editLoading:false,   //loading显示
                editForm:{
                    Id: 0,
                    PId:'',
                    TypeClass:1,
                    Title:'',
                    Ioc: null,
                    FirstPng:null,
                    IocUrl: null,
                    FirstPngUrl:null,
                    IocClick:null,
                    Status:0
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
                    BrandType:[{ required: true, message: "品牌标识必选", trigger: "blur" }]
                },
                IocimgList:[],
                firtimgList:[],
                ClickimgList:[],

                //所有二级分类
                TypeList:[],

                IsAdd:true  //是否
            }
        },
        methods: {
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },

            getPBTypePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getPBTypePageList(para).then((res) => {
                    console.log(res);
                    this.listLoading=false;
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getPBTypePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getPBTypePageList();
            },
            load(tree, treeNode, resolve) {
                let para = {
                    page: this.page,
                    id: tree.Id,
                };
                getPermissionTreeTable(para).then((res) => {
                    resolve(res.data.response);
                });
            },
            //查询
            query()
            {
               console.log("查询")
               console.log(this.search.title)
               
               this.page = 1;
               this.getPBTypePageList();
            },
            //删除
            handledel(row)
            {
                console.log(row);
                 this.$confirm("确认删除该产品信息吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    removePBType(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getPBTypePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
                this.editForm = { Id: 0,
                    PId: 0,
                    Title:'',
                    Type: 0,
                    Status:0,
                    Ioc: null,
                    FirstPng:null,
                    IocUrl: null,
                    FirstPngUrl:null
                };
                this.IocimgList = [];
                this.firtimgList =[];
                this.ClickimgList=[];
                this.GetTypeList();
                this.IsAdd = true;
                this.editFormVisible=true;
            },
            //编辑
            update(row){
                this.editForm = row;
                this.IocimgList = row.IocUrl?[{url: row.IocUrl}]:[];
                this.firtimgList = row.FirstPngUrl?[{url: row.FirstPngUrl}]:[];
                 this.ClickimgList=row.IocClickUrl?[{url: row.IocClickUrl}]:[];
                this.GetTypeList();
                this.IsAdd = false;
                this.editFormVisible=true;
            },
            IocImageChange(val)
            {
                this.IocimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'IocUrl',null);
                }   
            },
            firtImageChange(val)
            {
                this.firtimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'FirstPng',null);
                }   
            },
            ClickImageChange(val)
            {
                this.ClickimgList = val;
                if (val.length == 0) {
                    this.$set(this.editForm,'IocClick',null);
                }   
            },
            edithandleChange(val)
            {
                this.editForm.Type = val.length;
                this.editForm.PId = val[val.length - 1];
            },

            //查询所有二级分类
            GetTypeList()
            {
                let para={
                    children: false
                };
                GetTypeListAsync(para).then((res)=>{
                    if(res.data.success)
                    {
                        this.TypeList = res.data.response
                    }
                })

            },
            editSubmit(){
                this.$refs.editForm.validate((valid)=>{
                    if(valid)
                    {
                        this.$confirm("确认提交吗？", "提示", {}).then(() => {
                            this.editLoading = true;
                            let para = Object.assign({}, this.editForm);
                            const formData = new FormData();
                            if (this.IocimgList) {
                                let imgFil = this.IocimgList.filter((s) => s.status == "ready");
                                if (imgFil != null) {
                                    imgFil.forEach((it, index) => {
                                    formData.append("formIocImgs", it.raw);
                                    });
                                }
                            }
                            if (this.firtimgList) {
                                let imgFil = this.firtimgList.filter((s) => s.status == "ready");
                                if (imgFil != null) {
                                    imgFil.forEach((it, index) => {
                                    formData.append("formFirtImgs", it.raw);
                                    });
                                }
                            }
                            if (this.ClickimgList) {
                                let imgFil = this.ClickimgList.filter((s) => s.status == "ready");
                                if (imgFil != null) {
                                    imgFil.forEach((it, index) => {
                                    formData.append("formIocClickImgs", it.raw);
                                    });
                                }
                            }
                            formData.append("model", JSON.stringify(para));
                            Post(formData).then((res)=>{
                                this.editLoading = false;
                                if(res.data.success)
                                {
                                    this.$message({
                                    message: res.data.msg,
                                    type: "success",
                                    });
                                    this.editFormVisible=false;
                                    this.getPBTypePageList();
                                }else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: "error",
                                    });
                                }
                            })
                        });
                    }else{
                        return true;
                    }

                })

            }

        },
        mounted() {
              let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getPBTypePageList();
            // this.getPermissions();
        }
    }

</script>

<style>
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
